import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import {
  NavigationCancel, NavigationEnd, NavigationStart, Router,
} from '@angular/router';
import { ScrollRestorationService } from '@lib/scroll/scroll-restoration.service';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  filter, map, takeWhile, withLatestFrom,
} from 'rxjs/operators';
import { loadStateRequest } from './actions';
import { AppState } from './app-state';
import { AuthService } from './features/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  isAuthenticationConfigured = this.authService.configure().then(() => true);

  constructor(
    private router: Router,
    public authService: AuthService,
    tooltipConfig: NgbTooltipConfig,
    private scrollRestoration: ScrollRestorationService,
    private store: Store<AppState>,
  ) {
    // eslint-disable-next-line no-param-reassign
    tooltipConfig.container = 'body';
    this.authService.becameAuthenticated$.subscribe(() => {
      this.store.dispatch(loadStateRequest());
    });
  }

  isLoading$ = this.router.events.pipe(
    filter(
      (event) => event instanceof NavigationStart
        || event instanceof NavigationEnd
        || event instanceof NavigationCancel,
    ),
    withLatestFrom(this.isAuthenticationConfigured),
    map(([event, isAuthenticationConfigured]) => {
      const isNavigating: boolean = event instanceof NavigationStart;
      const isConfiguringAuthentication = !isAuthenticationConfigured;

      return isNavigating || isConfiguringAuthentication;
    }),
    takeWhile((isLoading) => isLoading, true),
  );

  ngAfterViewInit(): void {
    this.scrollRestoration.enable();
  }
}
